import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "d2-attendance",
  "use": "d2-attendance-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"d2-attendance\">\n  <defs>\n    <style>\n      #d2-attendance .cls-1 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"d2-attendance_圆角矩形_562\" data-name=\"圆角矩形 562\" class=\"cls-1\" d=\"M21,23H16V22h6V16h1v5A2,2,0,0,1,21,23ZM22,5H16V4h5a2,2,0,0,1,2,2v5H22V5ZM4,11H3V6A2,2,0,0,1,5,4h5V5H4v6Zm2,2H20v1H6V13ZM4,22h6v1H5a2,2,0,0,1-2-2V16H4v6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol